'use client'

import { Button } from 'ui'
import { usePDFStore } from '../../stores/pdf.store'
import { IconZoomIn, IconZoomOut } from '@tabler/icons-react'

const zoomRanges = [0.75, 1, 1.25, 1.5, 1.75, 2]

export const PDF_CONTROLS_PORTAL_ID = 'pdf-controls-portal'

export const ViewerControls = ({
  onZoomChange,
  zoom,
}: {
  zoom: number
  onZoomChange: (zoom: number) => void
}) => {
  const limits = {
    start: zoomRanges.at(0)!,
    end: zoomRanges.at(zoomRanges.length - 1)!,
  }

  return (
    <div className='h-14 text-white bg-brandblack w-full flex items-center justify-center relative'>
      <div id={PDF_CONTROLS_PORTAL_ID} />
      <div className='flex flex-row items-center space-x-2'>
        <Button
          size='sm'
          variant={'ghost'}
          disabled={zoom === limits.start}
          onClick={() => {
            const prev = zoomRanges[zoomRanges.findIndex((z) => z == zoom) - 1]

            onZoomChange(prev)
          }}
        >
          <IconZoomOut />
        </Button>
        <span>{zoom * 100}%</span>
        <Button
          size='sm'
          variant={'ghost'}
          onClick={() => {
            const next = zoomRanges[zoomRanges.findIndex((z) => z == zoom) + 1]

            onZoomChange(next)
          }}
          disabled={zoom === limits.end}
        >
          <IconZoomIn />
        </Button>
      </div>
    </div>
  )
}

export const PDFViewerControls = () => {
  const zoom = usePDFStore((store) => store.zoom)
  const update = usePDFStore((store) => store.update)

  return (
    <ViewerControls onZoomChange={(zoom) => update('zoom', zoom)} zoom={zoom} />
  )
}
